enum AlertTypeEnum {
    INFO = "info",
    WARNING = "warning",
    ERROR = "error"
}

export default AlertTypeEnum
